export default __webpack_public_path__ + "static/media/1895.f635b528.png";